import Component from './Component';

export default class ScrollComp extends Component {
  load() {

    let behaviorPref = 'auto';
    const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;

    if (!!isReduced) {
      console.log('prefers-reduced-motion');
    } else {
      // console.log('set smooth scroll');
      behaviorPref = 'smooth';
    }

    const scrollbtns = document.querySelectorAll('.scroll-comp');

    // Supports multiple scroll buttons
    scrollbtns.forEach(scrollbtn => {
      setupScrollButton(scrollbtn, calcScrollAmount);
    })

    super.load();


    function setupScrollButton(scrollbtn, calcScrollAmount) {
      // get scrollbtn parent that is a section element
      const parentSection = scrollbtn.closest('section');
      console.log('parentSection', parentSection);

      scrollbtn.addEventListener('click', () => {
        window.scroll(calcScrollAmount(parentSection));
      });
    }


    function calcScrollAmount(parentSection) {
      const elFeatureBanner = parentSection;
      const scrollYAmount = window.scrollY + elFeatureBanner.getBoundingClientRect().bottom;
      console.log('total height: ', scrollYAmount);

      const scrollOptions = {
        left: 0,
        top: scrollYAmount,
        behavior: behaviorPref
      };
      return scrollOptions;
    }

    // Can't scroll perfectly if their isn't enough room on page.
  }
}
